import React from 'react'

export default function PageNotFoundPage(){
    return (
        <div style={{textAlign: 'center', paddingTop: '10%'}}>
            <h1>404 - page not found</h1>
        </div>
    )
}